import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import api from "../lib/api";
import { ArrowLeft, ExternalLink } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setErr("Post not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="pt-32 pb-28 min-h-screen" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-10">
        <Link to="/blog" className="inline-flex items-center gap-2 text-fog-300 hover:text-volt text-sm mb-6">
          <ArrowLeft className="w-4 h-4" /> back to blog
        </Link>
        {loading && <p className="text-fog-300">Loading…</p>}
        {err && <p className="text-fog-300">{err}</p>}
        {post && (
          <article>
            <div className="flex items-center gap-3 mb-4">
              {post.subsubsection && (
                <span className="tag-chip">{post.subsubsection}</span>
              )}
              {post.url && (
                <a href={post.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-fog-300 hover:text-volt text-sm">
                  <ExternalLink className="w-4 h-4" /> Original
                </a>
              )}
            </div>
            <p className="overline text-volt">
              {post.ai_assisted ? "AI-ASSISTED" : "HUMAN-WRITTEN"} · {(post.tags || []).join(" · ")}
            </p>
            <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tighter mt-4 leading-[1.05]">
              {post.title}
            </h1>
            {post.excerpt && <p className="text-xl text-fog-300 mt-4">{post.excerpt}</p>}
            <div className="prose-invert-custom mt-10">
              <ReactMarkdown>{post.content}</ReactMarkdown>
            </div>
          </article>
        )}
      </div>
    </div>
  );
}
